import { render, staticRenderFns } from "./PlanName.vue?vue&type=template&id=741f5f60&scoped=true&"
import script from "./PlanName.vue?vue&type=script&lang=js&"
export * from "./PlanName.vue?vue&type=script&lang=js&"
import style0 from "./PlanName.vue?vue&type=style&index=0&id=741f5f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741f5f60",
  null
  
)

export default component.exports